import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import SectionTitle from '../../components/Common/SectionTitle';
import VideoStyleThree from '../../components/Video/VideoStyleThree';

// Import ProcessSection from the home folder
import ProcessSection from '../../pages/home/ProcessSection';

import Brand from '../../components/Common/Brand'
import CounterStyleThree from '../../components/Elements/Counter/CounterStyleThree';

const AboutMain = () => {
    // State to store API response data
    const [aboutData, setAboutData] = useState(null);

    // Fetch data from the API on component mount
    useEffect(() => {
        fetch('https://yautiktechnology.com/api/aboutpage')
            .then(response => response.json())
            .then(data => setAboutData(data))
            .catch(error => console.error('Error fetching about data:', error));
    }, []);

    // If aboutData is not available yet, return loading text or spinner
    if (!aboutData) {
        return <div>Loading...</div>;
    }

    return (
        <React.Fragment>
            {/* about-area-start */}
            <div id="rs-about" className="rs-about gray-bg pt-120 pb-120 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 md-mb-30">
                            <div className="rs-animation-shape">
                                <div className="images">
                                    <img src={aboutData.imgPath} alt="About Us" />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 pl-60 md-pl-14">
                            <div className="contact-wrap">
                                {/* Section Title Start */}
                                <SectionTitle
                                    sectionClass="sec-title mb-30"
                                    subtitleClass="sub-text style-bg"
                                    subtitle="About Us"
                                    titleClass="title pb-36"
                                    title={aboutData.title}
                                    descClass="desc pb-34"
                                    description={aboutData.description}
                                    secondDescClass="margin-0 pb-16"
                                    secondDescription={aboutData.subDescription}
                                />
                                {/* Section Title End */}
                                <div className="btn-part">
                                    <Link className="readon learn-more" to="/contact">Learn-More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* about-area-end */}

            {/* Include ProcessSection component */}
            <ProcessSection />

            {/* VideoStyleThree area start */}
            <div className="rs-contact-wrap bg7 pt-120 pb-390 md-pt-80" id="abt-cnt">
                <div className="container">
                    <SectionTitle
                        sectionClass="sec-title2 text-center mb-30"
                        subtitleClass="sub-text style-bg white-color"
                        subtitle="Contact"
                        titleClass="title white-color"
                        title="Request A Free Consultation"
                    />
                </div>
            </div>
            <VideoStyleThree />
            {/* VideoStyleThree area end */}

            {/* Counter Section Start */}
            <CounterStyleThree />
            {/* Counter Section Start */}

            {/* brand-area-start */}
            <Brand />
            {/* brand-area-end */}
        </React.Fragment>
    );
}

export default AboutMain;
